import React, { useState } from 'react';
import { Calculator } from './components/Calculator';
import { Wizard } from './components/wizard/Wizard';

export const App: React.FC = () => {
  const [useWizard, setUseWizard] = useState(true);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header - only show in advanced mode */}
      {!useWizard && (
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  Agentic Cost Calculator
                </h1>
              </div>
              <div className="flex items-center space-x-4">
                {/* Mode Toggle */}
                <button
                  onClick={() => setUseWizard(!useWizard)}
                  className="px-3 py-1 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  {useWizard ? 'Advanced Mode' : 'Guided Mode'}
                </button>
                <a
                  href="https://github.com/sammcj/agentic_cost_calc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </header>
      )}

      {/* Main Content */}
      <main className="w-full">
        {useWizard ? (
          <Wizard useWizard={useWizard} setUseWizard={setUseWizard} />
        ) : (
          <div className="py-8">
            <div className="mx-[5%]">
              <Calculator />
            </div>
          </div>
        )}
      </main>

      {/* Footer */}
      {!useWizard && (
        <footer className="bg-white mt-8 border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="text-center text-sm text-gray-500">
              <p>
                Developed by{' '}
                <a
                  href="https://twitter.com/s_mcleod"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800"
                >
                  @s_mcleod
                </a>
                {' | '}
                <a
                  href="https://github.com/sammcj/agentic_cost_calc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800"
                >
                  View on GitHub
                </a>
              </p>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
};

export default App;
